import { render, staticRenderFns } from "./FinalSurvey10.vue?vue&type=template&id=cb068f68&scoped=true&"
import script from "./FinalSurvey10.vue?vue&type=script&lang=js&"
export * from "./FinalSurvey10.vue?vue&type=script&lang=js&"
import style0 from "./FinalSurvey10.vue?vue&type=style&index=0&id=cb068f68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb068f68",
  null
  
)

export default component.exports